<template>
  <div :class="[collapse ? '' : 'mb-12']">
    <section
      class="w-full xl:flex xl:justify-between grid grid-cols-4 justify-start items-center border-b border-b-white/10 p-4 bg-white/5">

      <div class="col-span-3 sm:flex justify-start items-center sm:space-x-4 w-full">
        <div class="flex justify-start items-center space-x-4">
          <img class="w-10 h-10 rounded-md border border-white/20" :src="project.logo" alt="" />
          <p class="text-xl text-white">{{ project.name }}</p>
        </div>

        <div v-if="project.status == 'pre_contribute'" class="xl:pl-6 mt-2 xl:mt-0 font-light col-span-full wf">
          <div class="flex justify-start items-center">
            <p class="text-sm text-white mr-1">This project is pre-contribute</p>
            <button
              class="w-6 h-6 rounded-full bg-white/10 flex justify-center items-center text-xs btn min-h-0 p-0 m-0">?</button>
          </div>
          <p class="text-sm text-woodsmoke-100">Expect refunds after the project concludes</p>
        </div>

        <div v-if="project.status == 'concluded'" class="xl:pl-6 mt-2 xl:mt-0 font-light col-span-full">
          <div class="flex justify-start items-center">
            <p class="text-sm text-white mr-1">This project is concluded</p>
            <button
              class="w-6 h-6 rounded-full bg-white/10 flex justify-center items-center text-xs btn min-h-0 p-0 m-0">?</button>
          </div>
          <p class="text-sm text-woodsmoke-100">Shown amount is the exact amount you wil receive </p>
        </div>

      </div>

      <div class="w-full flex justify-end xl:items-center items-start h-full">
        <button @click="collapse = !collapse"
          class="btn xl:btn-sm flex justify-center items-center border-white/5 text-turquoise-500">
          <span class="xl:pr-2">{{ collapse ? 'Expand' : 'Collapse' }}</span>
          <Icon v-if="!collapse" name="solar:minimize-line-duotone"></Icon>
          <Icon v-if="collapse" name="solar:maximize-bold-duotone"></Icon>
        </button>

      </div>



    </section>

    <template v-if="!collapse">
      <template v-for="_pool in project.pools">

        <OTCPool @unlisted="unlisted()" :pool="_pool" :project="project"></OTCPool>

      </template>
    </template>

    <div class="p-4" v-if="!(project.pools.length > 0)">
      <p>No Record</p>
    </div>

  </div>
</template>

<script setup>

const emit = defineEmits(["unlisted"])

function unlisted() {
  emit('unlisted')
}

const props = defineProps({
  project: Object,
});

const { project } = toRefs(props);

const collapse = ref(false);

</script>

<style></style>
